import headerImage from './hero-image.svg';

export const testAttributes = {
    MORTGAGE_RATE_PAGE: 'mortgage-rate-page',
    MORTGAGE_RATE_CHART_CONTAINER: 'mortgage-rate-chart-container',
    MORTGAGE_RATE_HERO_SECTION: 'mortgage-rate-hero',
    MORTGAGE_RATE_ARTICLES_SECTION: 'mortgage-rate-articles',
    MAIN_BREADCRUMB_CONTAINER: 'main-breadcrumb-container',
    MORTGAGE_RATES_TABLE_CONTAINER: 'mortgage-rates-table-container',
}

export const defaultAttributes = {
    hero: {
        title: 'Today’s Mortgage Rates',
        description: 'Mortgage rates change daily based on the market. Here are today’s mortgage rates.',
        image: headerImage
    },
    ratesTable: {
        tool: 'rates',
        id: 'rates-app-id',
    }
}
